module.exports = __webpack_public_path__ + "static/img/IMG_20240610_125015.5bec0f1a.jpg";